import React from 'react'
import arrowIcon from '../../../assets/images/up-arrow.svg'
import steps from './steps.json'

import {
  Container,
  Step,
  StepDescription,
  StepDivider,
  StepImage,
  StepImageWrapper,
  StepTitle,
} from './RentalProcess.styled'

function RentalProcess() {
  return (
    <Container>
      {steps.map((step, index) => (
        <>
          {index !== 0 && <StepDivider key={step.title} src={arrowIcon} alt="" />}
          <Step key={index}>
            <StepImageWrapper>
              <StepImage src={step.icon} alt={step.title} />
            </StepImageWrapper>
            <StepTitle>
              {index + 1}. {step.title}
            </StepTitle>
            <StepDescription>{step.description}</StepDescription>
          </Step>
        </>
      ))}
    </Container>
  )
}

export default RentalProcess
